import { useTranslation } from "react-i18next";

type QuoteSelectionMode = "manual" | "auto";

type QuoteSelectionModeToggleProps = {
  mode: QuoteSelectionMode;
  onChange: (mode: QuoteSelectionMode) => void;
  className?: string;
};

export function QuoteSelectionModeToggle({
  mode,
  onChange,
  className = "",
}: QuoteSelectionModeToggleProps) {
  const { t } = useTranslation();

  return (
    <div className={`mt-4 flex w-full min-w-0 justify-start sm:w-auto ${className}`.trim()}>
      <div
        className="flex w-full max-w-full flex-col gap-1 rounded-3xl border border-darkBlue border-opacity-40 bg-white p-1 sm:inline-flex sm:w-auto sm:flex-row sm:flex-nowrap"
        role="group"
        aria-label="Request quote provider selection mode"
      >
        <button
          type="button"
          onClick={() => onChange("manual")}
          className={`w-full rounded-3xl px-3 py-2.5 text-center text-xs font-semibold leading-snug transition-colors sm:w-auto sm:shrink-0 sm:whitespace-nowrap sm:px-4 sm:py-2 sm:text-left sm:text-sm ${
            mode === "manual"
              ? "bg-darkBlue text-white"
              : "bg-transparent text-darkBlue hover:bg-blue-50"
          }`}
        >
          {t("selectUpTo3Providers")}
        </button>
        <button
          type="button"
          onClick={() => onChange("auto")}
          className={`w-full rounded-3xl px-3 py-2.5 text-center text-xs font-semibold leading-snug transition-colors sm:w-auto sm:shrink-0 sm:whitespace-nowrap sm:px-4 sm:py-2 sm:text-left sm:text-sm ${
            mode === "auto"
              ? "bg-darkBlue text-white"
              : "bg-transparent text-darkBlue hover:bg-blue-50"
          }`}
        >
          {t("autoSendToNearbyProviders")}
        </button>
      </div>
    </div>
  );
}
